const prefix = "agentspace.chat-draft.v1:";

export function chatDraftKey({ server, userId, tenantId, projectId, agentId }) {
  if (
    ![server, userId, tenantId, agentId].every(
      (part) => typeof part === "string" && part,
    )
  )
    return null;
  return JSON.stringify([server, userId, tenantId, projectId || null, agentId]);
}

export function createChatDrafts({ storage } = {}) {
  if (storage === undefined) {
    try {
      storage = globalThis.localStorage;
    } catch {
      storage = null;
    }
  }
  const texts = new Map();
  let current = null;
  return {
    /**
     * Switch to `key`'s draft and return the text the composer should show, or
     * null when the scope is unchanged. `typed` is the composer's text: text
     * typed while no scope was selected (the view was still opening) belongs
     * to the scope it opens into, so it is kept rather than replaced.
     */
    select(key, typed = "") {
      if (key === current) return null;
      const unscoped = current === null;
      current = key;
      if (!key) return "";
      if (unscoped && typed) {
        this.save(typed);
        return typed;
      }
      if (!texts.has(key)) {
        let text = "";
        try {
          const saved = storage?.getItem(prefix + key);
          if (typeof saved === "string" && saved.length <= 8000) text = saved;
        } catch {
          // Browser storage can be disabled; session drafts still work.
        }
        texts.set(key, text);
      }
      return texts.get(key);
    },
    save(text) {
      if (!current) return;
      texts.set(current, text);
      try {
        if (text) storage?.setItem(prefix + current, text);
        else storage?.removeItem(prefix + current);
      } catch {
        // A full or unavailable store must not interrupt typing or sending.
      }
    },
  };
}
